import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import ForgetPassword from "src/Components/Custom/ForgetPassword/ForgetPassword";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import VerficationModal from "src/Components/Custom/VerificationModal/VerificationModal";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import useAuth from "src/Hooks/Custom/useAuth";
import { useTranslation } from "react-i18next";
import DownloadAppSection from "../Intro/DownloadAppSection"

function LoginPage() {
  const { t,i18n } = useTranslation();
  const { register, errors, handleSubmit, watch } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onChange",
  });
  const {
    login,
    loading,
    verificationLoading,
    verify,
    isVerificationVisible,
    setIsVerificationVisible,
    forgetPasswordVisible,
    setForgetPasswordVisible,
    changePassword,
    forgetPassword,
    changePasswordVisible,
    setChangePasswordVisible,
  } = useAuth();

  const onSubmit = handleSubmit(login);

  return (
    <Fragment>
      <header className="login_header">
        <NavBar />
        <section className="login_section">
          <div className="container">
            <div className={`${i18n.dir() ==='rtl'?'row-reverse text-right':'row'}`}>
              <div className="col-md-6">
                <div className="col_selector"></div>
              </div>
              <div className="col-md-4">
                <div className="col_selector">
                  <h2 className={` mb-2 text-right ${i18n.dir()=== "rtl" ?"Almaraibold":"poppinssemibold"}`}>{t("Login")}</h2>
                  <form className={i18n.dir() === "rtl" ? "Almaraisemibold":"poppinsregular"}>
                    <div className="form-group">
                      <input
                        name={"email"}
                        ref={register({
                          required: {
                            value: true,
                            message: t("Email is required"),
                          },
                          pattern: {
                            value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/,
                            message: t("Email Address is invalid"),
                          },
                        })}
                        type="text"
                        className={`form-control ${errors.email ? "is-invalid" : ""
                          }`}
                        placeholder={t("Email Address")}
                      />
                      <VisibilityToggle visible={errors.email ? true : false}>
                        <p className="text-danger">{errors.email?.message}</p>
                      </VisibilityToggle>
                    </div>
                    <div className="form-group">
                      <input
                        name={"password"}
                        ref={register({
                          required: {
                            value: true,
                            message: t("Password is required"),
                          },
                        })}
                        type="password"
                        className={`form-control ${errors.password ? "is-invalid" : ""
                          }`}
                        placeholder={t("Password")}
                      />
                      <VisibilityToggle
                        visible={errors.password ? true : false}
                      >
                        <p className="text-danger">
                          {errors.password?.message}
                        </p>
                      </VisibilityToggle>
                    </div>
                    <div className="form-group">
                      <button
                        disabled={loading}
                        className={`btn custom_btn w-100 ${i18n.dir() === "rtl" ? "Almaraibold":""}`}
                        onClick={onSubmit}
                      >
                        <VisibilityToggle visible={loading}>
                          <span className="spinner-border spinner-border-sm"></span>
                          &nbsp;
                        </VisibilityToggle>
                        {t("Login")}
                      </button>
                    </div>
                    <div className="form-group">
                      <p className="mb-0 text-right">
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            setForgetPasswordVisible(true);
                          }}
                          className="base_color"
                        >
                          {t("Forgot password?")}
                        </a>
                      </p>
                    </div>
                    <div>
                      <p className="text-right fz14">
                        {t("Don't have an account?")}
                        <Link to={"/signup"} className="font-weight-bold ml-1">
                          {t("Sign Up")}
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </header>
      <DownloadAppSection />
      <Footer />
      <CopyRight />
      <VerficationModal
        email={watch("email")}
        cb={onSubmit}
        verificationLoading={verificationLoading}
        verify={verify}
        isVerificationVisible={isVerificationVisible}
        setIsVerificationVisible={setIsVerificationVisible}
      />
      <ForgetPassword
        visible={forgetPasswordVisible}
        loading={loading}
        setVisible={setForgetPasswordVisible}
        changePassword={changePassword}
        forgetPassword={forgetPassword}
        changePasswordVisible={changePasswordVisible}
        setChangePasswordVisible={setChangePasswordVisible}
      />
    </Fragment>
  );
}

export default LoginPage;
